module.exports = __webpack_public_path__ + "media/svg/original_light_horizontal-dbd60f7d.svg";